var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "companion vertical",
      on: {
        change: function($event) {
          _vm.companion.changed = true
        },
        keyup: function($event) {
          _vm.companion.changed = true
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "companion-top horizontal center between" },
        [
          _c(
            "f9button",
            {
              staticClass: "companion-name",
              class: {
                changed:
                  _vm.changed &&
                  (_vm.companion.firstName || _vm.companion.lastName)
              },
              attrs: { nostyle: "" },
              on: {
                click: function($event) {
                  _vm.companion.expanded = !_vm.companion.expanded
                }
              }
            },
            [
              _c("span", {
                attrs: { "data-cs-mask": "" },
                domProps: { innerHTML: _vm._s(_vm.getName(_vm.companion)) }
              }),
              _vm._v(
                " [" +
                  _vm._s(_vm.companion.expanded ? "-" : "+") +
                  "]\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "f9button",
            {
              staticClass: "companion-remove horizontal right center",
              attrs: { nostyle: "" },
              on: {
                click: function($event) {
                  _vm.$emit("delete", _vm.companion)
                }
              }
            },
            [
              _vm._v("Remove "),
              _c("img", {
                attrs: {
                  src: require("images/Loyalty/Icons/remove.svg"),
                  alt: ""
                }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.companion.expanded,
              expression: "companion.expanded"
            }
          ],
          staticClass: "companion-form left",
          class: { vertical: _vm.companion.expanded }
        },
        [
          _c(
            "f9field",
            [
              _c(
                "span",
                {
                  staticClass: "slider-label",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [_c("em", [_vm._v("FRONTIER Miles")]), _vm._v(" #")]
              ),
              _vm._v(" "),
              _c("f9input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "numeric",
                    expression: "'numeric'"
                  }
                ],
                attrs: {
                  saved: !_vm.changed,
                  type: "text",
                  name: "member_number",
                  "data-vv-scope": _vm.validationScope,
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.companion.milesNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.companion, "milesNumber", $$v)
                  },
                  expression: "companion.milesNumber"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slider-form-row" },
            [
              _c(
                "f9field",
                { attrs: { label: "First Name*" } },
                [
                  _c("f9input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      saved: !_vm.changed,
                      type: "text",
                      name: "first_name",
                      "data-vv-scope": _vm.validationScope,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.companion.firstName,
                      callback: function($$v) {
                        _vm.$set(_vm.companion, "firstName", $$v)
                      },
                      expression: "companion.firstName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "f9field",
                { attrs: { label: "Middle Name" } },
                [
                  _c("f9input", {
                    attrs: {
                      saved: !_vm.changed,
                      type: "text",
                      name: "middle_name",
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.companion.middleName,
                      callback: function($$v) {
                        _vm.$set(_vm.companion, "middleName", $$v)
                      },
                      expression: "companion.middleName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f9field",
            { attrs: { label: "Last Name*" } },
            [
              _c("f9input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  saved: !_vm.changed,
                  type: "text",
                  name: "last_name",
                  "data-vv-scope": _vm.validationScope,
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.companion.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.companion, "lastName", $$v)
                  },
                  expression: "companion.lastName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slider-form-row" },
            [
              _c(
                "f9field",
                { attrs: { label: "Gender*", half: "" } },
                [
                  _c(
                    "f9select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        saved: !_vm.changed,
                        name: "gender",
                        "data-vv-scope": _vm.validationScope,
                        disabled: _vm.disabled
                      },
                      model: {
                        value: _vm.companion.gender,
                        callback: function($$v) {
                          _vm.$set(_vm.companion, "gender", $$v)
                        },
                        expression: "companion.gender"
                      }
                    },
                    [
                      _c("option", { attrs: { "data-cs-mask": "" } }, [
                        _vm._v("--")
                      ]),
                      _vm._v(" "),
                      _c(
                        "option",
                        { attrs: { "data-cs-mask": "", value: "M" } },
                        [_vm._v("Male")]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        { attrs: { "data-cs-mask": "", value: "F" } },
                        [_vm._v("Female")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "f9field",
                { attrs: { label: "Date of Birth*", half: "" } },
                [
                  _c("f9date", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      saved: !_vm.changed,
                      name: "birth_date",
                      "data-vv-scope": _vm.validationScope,
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.companion.dob,
                      callback: function($$v) {
                        _vm.$set(_vm.companion, "dob", $$v)
                      },
                      expression: "companion.dob"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slider-field" },
            [
              _c(
                "f9button",
                {
                  staticClass: "slider-label",
                  attrs: { nostyle: "" },
                  on: {
                    click: function($event) {
                      _vm.companion.passportExpanded = !_vm.companion
                        .passportExpanded
                    }
                  }
                },
                [
                  _vm._v(
                    "Passport [" +
                      _vm._s(_vm.companion.passportExpanded ? "-" : "+") +
                      "]"
                  )
                ]
              ),
              _vm._v(" "),
              _c("passport", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.companion.passportExpanded,
                    expression: "companion.passportExpanded"
                  }
                ],
                attrs: {
                  "not-required": "",
                  member: _vm.member,
                  passport: _vm.companion.passport,
                  "allow-remove": false,
                  "validation-scope": _vm.validationScope
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f9field",
            [
              _c(
                "f9button",
                {
                  staticClass: "slider-label",
                  attrs: { nostyle: "" },
                  on: {
                    click: function($event) {
                      _vm.companion.ktnExpanded = !_vm.companion.ktnExpanded
                    }
                  }
                },
                [
                  _vm._v(
                    "Known Traveler Number [" +
                      _vm._s(_vm.companion.ktnExpanded ? "-" : "+") +
                      "]"
                  )
                ]
              ),
              _vm._v(" "),
              _c("f9input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.companion.ktnExpanded,
                    expression: "companion.ktnExpanded"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "alpha_num|min:7|max:25",
                    expression: "'alpha_num|min:7|max:25'"
                  }
                ],
                staticClass: "sub-field",
                attrs: {
                  saved: !_vm.changed,
                  type: "text",
                  maxlength: "25",
                  "data-vv-scope": _vm.validationScope,
                  name: "ktn",
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.companion.knownTravelerNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.companion, "knownTravelerNumber", $$v)
                  },
                  expression: "companion.knownTravelerNumber"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f9field",
            [
              _c(
                "f9button",
                {
                  staticClass: "slider-label",
                  attrs: { nostyle: "" },
                  on: {
                    click: function($event) {
                      _vm.companion.redressExpanded = !_vm.companion
                        .redressExpanded
                    }
                  }
                },
                [
                  _vm._v(
                    "Redress Number [" +
                      _vm._s(_vm.companion.redressExpanded ? "-" : "+") +
                      "]"
                  )
                ]
              ),
              _vm._v(" "),
              _c("f9input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.companion.redressExpanded,
                    expression: "companion.redressExpanded"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "alpha_num|min:6|max:13",
                    expression: "'alpha_num|min:6|max:13'"
                  }
                ],
                staticClass: "sub-field",
                attrs: {
                  saved: !_vm.changed,
                  type: "text",
                  maxlength: "13",
                  "data-vv-scope": _vm.validationScope,
                  name: "redress",
                  disabled: _vm.disabled
                },
                model: {
                  value: _vm.companion.redressNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.companion, "redressNumber", $$v)
                  },
                  expression: "companion.redressNumber"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a9ea1a6", { render: render, staticRenderFns: staticRenderFns })
  }
}